/** Reglas de formulario de «Actualizar» (espejo de dominio/ficha-cliente.js del servidor; el servidor manda). */
import { AbstractControl, ValidationErrors } from '@angular/forms';

const CORREO = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

/** Teléfono venezolano: 10 dígitos tras quitar 58 y el 0 inicial (0414 111 2233 · +58 414 111 2233). */
export function telefonoVenezolano(raw: string): boolean {
  let d = (raw || '').replace(/\D/g, '');
  if (d.startsWith('58')) d = d.slice(2);
  if (d.length === 11 && d.startsWith('0')) d = d.slice(1);
  return d.length === 10;
}

export function validarCorreoOpcional(c: AbstractControl): ValidationErrors | null {
  const v = String(c.value || '').trim();
  return !v || CORREO.test(v) ? null : { correo: true };
}

export function validarTelefonoOpcional(c: AbstractControl): ValidationErrors | null {
  const v = String(c.value || '').trim();
  return !v || telefonoVenezolano(v) ? null : { telefono: true };
}
